import { SideNavInterface } from '../../interfaces/side-nav.type';
export const MAINROUTES: SideNavInterface[] = [
    {
        path: '/dashboard/default',
        title: 'Dashboard',
        iconType: 'nzIcon',
        iconTheme: 'fill',
        icon: 'dashboard',
        submenu: []
    },
    {
        path: '',
        title: 'My Shipments',
        iconType: 'fontawesome',
        iconTheme: 'fas',
        icon: 'fa-ship',
        submenu: []
    },
    {
        path: '',
        title: 'Track New Shipment',
        iconType: 'fontawesome',
        iconTheme: 'fas',
        icon: 'fa-home',
        submenu: []
    },
     
    {
        path: '',
        title: 'Gate Out Tracing',
        iconType: 'fontawesome',
        iconTheme: 'fas',
        icon: 'fa-truck',
        submenu: [
            { 
                path: '',
                title: 'Latest Gate Outs', 
                iconType: '', 
                icon: '',
                iconTheme: '',
                submenu: [] 
            },
            { 
                path: '',
                title: 'Waiting Containers', 
                iconType: '', 
                icon: '',
                iconTheme: '',
                submenu: [] 
            },
            { 
                path: '',
                title: 'Waiting Cont. (80+)', 
                iconType: '', 
                icon: '',
                iconTheme: '',
                submenu: [] 
            },
        ]
    
    },
    
    {
        path: '',
        title: 'Gate In Tracing',
        iconType: 'fontawesome',
        iconTheme: 'fas',
        icon: 'fa-boxes',
        submenu: [
            { 
                path: '',
                title: 'Latest Gate Ins', 
                iconType: '', 
                icon: '',
                iconTheme: '',
                submenu: [] 
            },
            { 
                path: '',
                title: 'Waiting Containers', 
                iconType: '', 
                icon: '',
                iconTheme: '',
                submenu: [] 
            },
            { 
                path: '',
                title: 'Waiting Cont. (80+)', 
                iconType: '', 
                icon: '',
                iconTheme: '',
                submenu: [] 
            },
        ]
    }
]    
